import React from "react";
import "@frameworks/shared-library/stylesheets/components/FolioSelection/FolioSelection.scss";
import { roundUpToThreeDecimalPlaces } from "@domains/utils/numberMethods";
export var RadioBtnHoldingdata = function (_a) {
    var units = _a.units, amount = _a.amount, schemeName = _a.schemeName;
    return (React.createElement("div", { className: "d-flex flex-column holding-data-container" },
        React.createElement("div", { className: "RobotoM_14_400 txt-midnight-blue lh-120" },
            React.createElement(React.Fragment, null, schemeName)),
        React.createElement("div", { className: "card-content" },
            React.createElement("div", { className: "RobotoM_14_400 txt-grey-shade1 lh-120" },
                "\u20B9 ",
                roundUpToThreeDecimalPlaces(+amount)),
            React.createElement("div", { className: "unitsContainer DMsanR_10_400 lh-140 txt_blackOne1" },
                React.createElement("div", { className: "units" },
                    "Units: ",
                    roundUpToThreeDecimalPlaces(+units))))));
};
